// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".permission-grid-height[data-v-d0b93626] {\n  height: 500px;\n  min-height: 350px;\n}\n.action-button[data-v-d0b93626] {\n  margin: 4px;\n}\n[data-v-d0b93626] .ag-theme-balham .ag-row-selected::before {\n  background-color: transparent;\n}\n", ""]);
// Exports
module.exports = exports;
